import styled from '../../utils/styled'

type CardProps = {
  inactive?: boolean
}

export const Card = styled.div<CardProps>`
  border-radius: 0.5rem;
  background-color: ${({ theme, inactive }) => (inactive ? theme.colors.borders : theme.colors.white)};
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;
  & hr {
    margin: 0 -1.5rem;
  }
`
